import { render, staticRenderFns } from "./category.vue?vue&type=template&id=5100b0c8&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5100b0c8')) {
      api.createRecord('5100b0c8', component.options)
    } else {
      api.reload('5100b0c8', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=5100b0c8&", function () {
      api.rerender('5100b0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/joypal/category.vue"
export default component.exports